import type { ApiUserPermission } from "avvir";
import type { AvvirEvent } from "type_aliases";

export type UserPermissionCreatedEvent = AvvirEvent<typeof USER_PERMISSION_CREATED, ApiUserPermission>

const userPermissionCreated = (permission: ApiUserPermission): UserPermissionCreatedEvent => ({
  type: USER_PERMISSION_CREATED,
  payload: permission
});

export const USER_PERMISSION_CREATED = "user_permission_created";

export default userPermissionCreated;
